import { fetchData } from "@client";

export async function getSharedProjectsQuery() {
  const { results } = await fetchData("/project/shared");
  return results;
}

